/**
 * AllRounderLogo — wordmark only (mark removed per user request).
 */
const NAVY = "#15355C";

function Wordmark({ color = NAVY, className = "" }) {
  return (
    <span
      className={className}
      style={{
        fontFamily: "'Fraunces', 'Playfair Display', Georgia, serif",
        fontWeight: 600,
        fontOpticalSizing: "auto",
        fontVariationSettings: '"opsz" 144',
        color,
        letterSpacing: "-0.01em",
        lineHeight: 1,
      }}
    >
      All Rounder
    </span>
  );
}

export default function AllRounderLogo({
  variant = "lockup",
  color = NAVY,
  className = "",
  wordmarkClassName = "",
}) {
  const sizeClass =
    variant === "horizontal"
      ? "text-[19px]"
      : variant === "mark"
      ? "text-[28px]"
      : "text-[44px] sm:text-[52px]";
  return (
    <span className={`inline-flex items-center ${className}`}>
      <Wordmark color={color} className={`${sizeClass} ${wordmarkClassName}`} />
    </span>
  );
}
